export default __webpack_public_path__ + "static/media/480_dummy2016-schauspieler01-mobile-de.eb8d0fee.png";